import { render, staticRenderFns } from "./RoleManagementDialog.vue?vue&type=template&id=3625fbb6&scoped=true&"
import script from "./RoleManagementDialog.vue?vue&type=script&lang=js&"
export * from "./RoleManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementDialog.vue?vue&type=style&index=0&id=3625fbb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625fbb6",
  null
  
)

export default component.exports